
if (window.__bootstrapLoaded !== true) {
  require('bootstrap');
  window.__bootstrapLoaded = true;
}

window.tabsInitialized = false;

const initConnectedTabs = () => {
    if (window.tabsInitialized) return;
    const connectedTabsBlocks = document.querySelectorAll('.connected-tabs');
    if (!connectedTabsBlocks.length) return;

    const groupedBlocks = groupBlocksByIdentifier(connectedTabsBlocks);
    
    Object.values(groupedBlocks).forEach(initConnectedTabsGroup);
    window.tabsInitialized = true;
}

const groupBlocksByIdentifier = (blocks) => {
    const groups = {};
    
    blocks.forEach(block => {
        const identifier = block.dataset.tabGroup;
        if (!identifier) return;
        
        const baseIdentifier = identifier.split('-')[0];
        if (!groups[baseIdentifier]) {
            groups[baseIdentifier] = [];
        }
        groups[baseIdentifier].push(block);
    });
    
    return groups;
}

const initConnectedTabsGroup = (groupBlocks) => {
    groupBlocks.forEach(block => {
        const tabsInner = block.querySelectorAll('.connected-tabs-inner');
        if (!tabsInner.length) return;
        
        Array.from(tabsInner).forEach(tabsBlock => 
            initTabsBlock(tabsBlock, groupBlocks)
        );
    });
}

const initTabsBlock = (tabsBlock, groupBlocks) => {
    const firstTab = tabsBlock.querySelector('.connected-tabs-inner li[data-toggle="tab"]');
    if (!firstTab) return;
    
    $(firstTab).tab('show');
    
    const tabs = tabsBlock.querySelectorAll('[data-toggle="tab"]');
    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => 
            handleTabClick(tab, index, tabsBlock, groupBlocks)
        );
    });
}

const handleTabClick = (clickedTab, index, currentTabsBlock, groupBlocks) => {
    const elements = getTabElements(clickedTab, currentTabsBlock);
    if (!elements) return;
    
    updateTabsVisibility(elements);
    synchronizeGroupTabs(index, currentTabsBlock, groupBlocks);
}

const getTabElements = (tab, tabsBlock) => {
    const targetContent = tabsBlock.querySelector(`[data-tab-content="${tab.dataset.tab}"]`);
    const navLink = tab.querySelector('.nav-link');
    if (!targetContent || !navLink) return null;
    
    return {
        content: targetContent,
        navLink: navLink
    };
}

const updateTabsVisibility = ({ content, navLink }) => {
    const allContents = content.parentElement?.querySelectorAll('.connected-tabs-inner-content');
    allContents?.forEach(content => content.classList.add('hidden'));
    
    content.classList.remove('hidden');
    
    const tabsList = navLink.closest('.tab-nav__list');
    if (tabsList) {
        tabsList.querySelectorAll('.tab-nav__list-item').forEach(item => {
            item.classList.remove('active');
            item.querySelector('.nav-link')?.classList.remove('active');
        });
        
        const listItem = navLink.closest('.tab-nav__list-item');
        if (listItem) {
            listItem.classList.add('active');
            navLink.classList.add('active');
        }
    }
}

const synchronizeGroupTabs = (clickedTabIndex, currentTabsBlock, groupBlocks) => {
    groupBlocks.forEach(block => {
        const tabsInner = block.querySelectorAll('.connected-tabs-inner');
        tabsInner.forEach(tabsBlock => {
            if (tabsBlock === currentTabsBlock) return;
            
            const tabs = tabsBlock.querySelectorAll('[data-toggle="tab"]');
            const correspondingTab = tabs[clickedTabIndex];
            
            if (correspondingTab) {
                $(correspondingTab).tab('show');
                
                const elements = getTabElements(correspondingTab, tabsBlock);
                if (elements) {
                    updateTabsVisibility(elements);
                }
            }
        });
    });
}

window.addEventListener('DOMContentLoaded', initConnectedTabs);